import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const NetworkToolsAndroid: React.FC = () => (
  <SEOLandingPage
    title="Network Tools for Android — Ping, DNS Lookup & Port Checker on Your Phone | Cosmovex"
    metaDescription="Network Tools for Android. Ping hosts, DNS lookup, port checker, IP address finder, speed test, and network stats. Diagnose connectivity issues from your Android phone."
    ogTitle="Network Tools for Android"
    h1="Network Diagnostic Tools for Android"
    intro="A comprehensive suite of network utilities for Android. Ping, DNS lookup, port checker, IP finder, and speed test — everything you need to diagnose connectivity issues from your phone."
    paragraphs={[
      "Network issues don't wait until you're at a desktop. Whether you're on-site troubleshooting a server, checking if a port is reachable, or diagnosing a connectivity problem from your phone, you need reliable network tools in your pocket. Network Tools for Android puts a full diagnostic toolkit on your device.",
      "Ping any hostname or IP address to check connectivity and measure round-trip time. See min, max, and average latency across multiple packets. DNS Lookup resolves domain names to IP addresses and returns all DNS record types (A, AAAA, MX, CNAME, TXT, NS). Useful for diagnosing DNS propagation issues or checking DNS configuration.",
      "The port checker tells you whether a specific port is open and accepting connections on any host. Diagnose firewall issues, check if a service is running, or verify that your port forwarding is working correctly. The IP address finder shows your current local and public IP addresses — useful when your IP has changed and you need to know it fast.",
      "Run a speed test to measure your current internet connection speed. View detailed network statistics including Wi-Fi signal strength, connection type, and interface information. Perfect for network administrators, IT support professionals, developers, and power users who need quick diagnostics without carrying a laptop.",
    ]}
    features={[
      "Ping with latency statistics (min/max/avg)",
      "DNS lookup — all record types",
      "Port checker — open/closed status",
      "Local and public IP address finder",
      "Internet speed test",
      "Wi-Fi network information",
      "Signal strength and connection details",
      "Works on Wi-Fi and mobile data",
      "Clean, dark developer interface",
      "No account or login required",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.nettoolkit"
    icon="/images/nettoolkit.png"
    appName="Network Tools"
    accentColor="#A8720E"
    canonicalPath="/network-tools-android"
  />
);

export default NetworkToolsAndroid;
